/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TaskInfo = {
    properties: {
        id: {
            type: 'string',
            isRequired: true,
        },
        status: {
            type: 'string',
            description: `The task's current state. Possible values include: *PENDING*: The task is waiting for execution. *STARTED*: The task has been started. *RETRY*: The task is to be retried, possibly because of failure. *FAILURE*: The task raised an exception or has exceeded the retry limit. *SUCCESS*: The task executed successfully.`,
            isRequired: true,
        },
        result: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
    },
} as const;
